import script from "./ButtonSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSimple.vue?vue&type=script&setup=true&lang=js"

import "./ButtonSimple.vue?vue&type=style&index=0&id=04ad924a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ad924a"]])

export default __exports__